import type { SocketConfig } from "../types";

export const SOCKET_CONFIG: SocketConfig = {
  serverUrl: "https://selfiecam.evensoft.fr",
  path: "/ws",
  transports: ["websocket", "polling"],
};
